import { render, staticRenderFns } from "./IntakeTypeDisplay.vue?vue&type=template&id=156b34a3&scoped=true&"
import script from "./IntakeTypeDisplay.vue?vue&type=script&lang=js&"
export * from "./IntakeTypeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156b34a3",
  null
  
)

export default component.exports